import { render, staticRenderFns } from "./ArtworkSlideShow.vue?vue&type=template&id=6771d982&"
import script from "./ArtworkSlideShow.vue?vue&type=script&lang=js&"
export * from "./ArtworkSlideShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports